export default __webpack_public_path__ + "static/media/nen_logo_white.a8fd86f0.svg";